export const state = () => ({
	candidate: null,
});

export const mutations = {
	setCandidate(state: any, payload: object) {
		state.candidate = payload;
	},
};

export const getters = {
	getCandidate: (state: any) => state.candidate,
};

export const actions = {
	getFullCandidateProfile(state: any, payload: any) {
		const { candidate_uuid, ...data } = payload;

		return new Promise((resolve, reject) => {
			this.$axios
				.get(`/api/candidate/profile/${candidate_uuid}`, { params: data })
				.then((res) => {
					state.commit('setCandidate', res.data);

					state.dispatch(
						'applications/recordCandidateProfileView',
						{
							profile_uuid: candidate_uuid,
							redacted: false,
						},
						{ root: true },
					);

					resolve(res.data);
				})
				.catch((err) => {
					reject(err);
				});
		});
	},

	downloadCV(state: any, candidate_uuid: string) {
		return new Promise((resolve, reject) => {
			this.$axios
				.post(`/api/candidate/download-cv/${candidate_uuid}`)
				.then((res) => {
					resolve(res);
				})
				.catch((err) => {
					reject(err);
				});
		});
	},

	downloadMultipleCVs(state: any, candidate_uuids: string) {
		return new Promise((resolve, reject) => {
			this.$axios
				.post(`/api/candidate/download-multiple-cvs`, { candidate_uuids: candidate_uuids })
				.then((res) => {
					resolve(res);
				})
				.catch((err) => {
					reject(err);
				});
		});
	},
};
